import { QPoint } from "../CoreApp/QPoint";

export function GetBaseBoxSize(aLayout) {
  var pt = new QPoint();
  var l = aLayout;
  var c0H = l.GetCellDesc(0, 1);
  var c1 = l.GetCellDesc(1, 1);
  var c2H = l.GetCellDesc(2, 1);
  var c0V = l.GetCellDesc(1, 0);
  var c2V = l.GetCellDesc(1, 2);

  pt.fX = c1.GetSPictureWidth() + c0H.GetCellWidth() + c2H.GetCellWidth();
  pt.fY = c1.GetSPictureHeight() + c0V.GetCellHeight() + c2V.GetCellHeight();

  return pt;
}
